import React from 'react'
import { Outlet } from 'react-router-dom'

import { AnalyticsProvider } from './providers/AnalyticsProvider'

export const AnalyticsRouteWrapper = () => {
  return (
    <AnalyticsProvider>
      <Outlet />
    </AnalyticsProvider>
  )
}
